import type { ReactNode } from "react";
import classNames from "classnames";
import type { Argument } from "classnames";

export interface FooterProps {
  children: ReactNode;
  className?: Argument;
  containerClassName?: Argument;
  hideFooter?: boolean;
}

export const Footer = ({
  children,
  hideFooter,
  className = "absolute",
  containerClassName,
}: FooterProps) => {
  if (hideFooter) return null;

  return (
    <div
      className={classNames(
        "bg-primary border-primary bottom-0 left-0 w-full justify-center border-t",
        className,
      )}
    >
      <div
        className={classNames(
          "mx-auto max-w-screen-md px-6 py-4",
          containerClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};
